/**
 * Lab máscaras — /pages/mascaras (spec 0091)
 * Rich text (contenteditable) + chips de máscara + preview tiles.
 * Espelha gm-apply-modelo-masks.liquid no client.
 */
(function () {
  var KNOWN_MASKS = {
    '{cor}': 1,
    '{material}': 1,
    '{acabamento}': 1,
    '{edicao}': 1,
    '{nome}': 1,
    '{modelo}': 1,
    '{titulo}': 1,
  };
  var TOKEN_RE = /\{(cor|material|acabamento|edicao|nome|modelo|titulo)\}/g;
  /** Qualquer `{token}` estilo máscara (válida ou não). */
  var ANY_MASK_RE = /\{[a-z][a-z0-9_]*\}/g;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isKnownMask(token) {
    return !!KNOWN_MASKS[String(token || '')];
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function buildMaskMap(product, modeloNome) {
    return {
      '{cor}': product.cor || '',
      '{material}': product.material || '',
      '{acabamento}': product.material || '',
      '{edicao}': product.edicao || '',
      '{nome}': product.modeloNome || modeloNome || '',
      '{modelo}': product.modeloNome || modeloNome || '',
      '{titulo}': product.title || '',
    };
  }

  /** Tokens usados no template cujo valor no produto está vazio. */
  function missingMaskValues(html, product, modeloNome) {
    var map = buildMaskMap(product, modeloNome);
    var missing = [];
    String(html || '').replace(TOKEN_RE, function (token) {
      var val = map[token];
      if (
        (val == null || String(val).trim() === '') &&
        missing.indexOf(token) === -1
      ) {
        missing.push(token);
      }
      return token;
    });
    return missing;
  }

  function applyMasks(html, product, modeloNome) {
    var map = buildMaskMap(product, modeloNome);
    return String(html || '')
      .replace(TOKEN_RE, function (token) {
        return map[token] != null ? map[token] : '';
      })
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/ \./g, '.')
      .replace(/ ,/g, ',');
  }

  /** Máscaras `{…}` que sobraram (não existem no sistema). */
  function unresolvedTokens(html) {
    var found = [];
    String(html || '').replace(ANY_MASK_RE, function (t) {
      if (!isKnownMask(t) && found.indexOf(t) === -1) found.push(t);
      return t;
    });
    return found;
  }

  /** Marca máscaras inválidas em vermelho no HTML do preview. */
  function highlightInvalidMasks(html) {
    return String(html || '').replace(ANY_MASK_RE, function (token) {
      if (isKnownMask(token)) return token;
      return (
        '<span class="gm-lab-mascaras__mask-invalid">' + esc(token) + '</span>'
      );
    });
  }

  function tokenClassName(token) {
    return (
      'gm-lab-mascaras__token' +
      (isKnownMask(token) ? '' : ' gm-lab-mascaras__token--invalid')
    );
  }

  function createTokenEl(token) {
    var span = document.createElement('span');
    span.className = tokenClassName(token);
    span.setAttribute('data-mask', token);
    if (!isKnownMask(token)) span.setAttribute('data-mask-invalid', '1');
    span.setAttribute('contenteditable', 'false');
    span.textContent = token;
    return span;
  }

  /** Plain `{cor}` / `{xyz}` in HTML → visual token pills in the editor. */
  function decorateTokens(html) {
    return String(html || '').replace(ANY_MASK_RE, function (token) {
      return (
        '<span class="' +
        tokenClassName(token) +
        '" data-mask="' +
        esc(token) +
        '"' +
        (isKnownMask(token) ? '' : ' data-mask-invalid="1"') +
        ' contenteditable="false">' +
        esc(token) +
        '</span>'
      );
    });
  }

  /** Editor DOM → HTML with plain `{cor}` tokens (for preview / Admin). */
  function serializeEditor(rte) {
    var clone = rte.cloneNode(true);
    var tokens = clone.querySelectorAll('[data-mask]');
    for (var i = 0; i < tokens.length; i++) {
      var span = tokens[i];
      var text = document.createTextNode(span.getAttribute('data-mask') || '');
      span.parentNode.replaceChild(text, span);
    }
    // Strip Shopify metafield_tag wrappers if present
    var html = clone.innerHTML || '';
    html = html.replace(
      /<div[^>]*class="[^"]*metafield-rich_text_field[^"]*"[^>]*>/gi,
      ''
    );
    html = html.replace(/<\/div>\s*$/i, '');
    return html.trim();
  }

  function setEditorHtml(rte, html) {
    var cleaned = String(html || '')
      .replace(/<div[^>]*class="[^"]*metafield-rich_text_field[^"]*"[^>]*>/gi, '')
      .replace(/<\/div>\s*$/i, '')
      .trim();
    rte.innerHTML = decorateTokens(cleaned || '<p><br></p>');
    syncPlaceholder(rte);
  }

  function syncPlaceholder(rte) {
    var text = (rte.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (text) rte.removeAttribute('data-empty');
    else rte.setAttribute('data-empty', '1');
  }

  function getCaretPlainOffset(rte) {
    var sel = window.getSelection();
    if (!sel || !sel.rangeCount) return 0;
    var range = sel.getRangeAt(0);
    var pre = range.cloneRange();
    pre.selectNodeContents(rte);
    pre.setEnd(range.startContainer, range.startOffset);
    return pre.toString().length;
  }

  function setCaretPlainOffset(rte, offset) {
    var walker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT, null);
    var remaining = Math.max(0, offset || 0);
    while (walker.nextNode()) {
      var node = walker.currentNode;
      var len = (node.nodeValue || '').length;
      var maskEl =
        node.parentElement && node.parentElement.closest
          ? node.parentElement.closest('[data-mask]')
          : null;

      if (remaining <= len) {
        var range = document.createRange();
        if (maskEl) {
          range.setStartAfter(maskEl);
        } else {
          range.setStart(node, remaining);
        }
        range.collapse(true);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        return;
      }
      remaining -= len;
    }
    var end = document.createRange();
    end.selectNodeContents(rte);
    end.collapse(false);
    var sel2 = window.getSelection();
    sel2.removeAllRanges();
    sel2.addRange(end);
  }

  /** Converte `{cor}` / `{xyz}` digitado (texto puro) nas pills do editor. */
  function promoteTypedTokens(rte) {
    var offset = getCaretPlainOffset(rte);
    var changed = false;
    var walker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (var i = 0; i < nodes.length; i++) {
      var textNode = nodes[i];
      if (!textNode.parentNode) continue;
      if (
        textNode.parentElement &&
        textNode.parentElement.closest('[data-mask]')
      ) {
        continue;
      }
      var text = textNode.nodeValue || '';
      if (!/\{[a-z][a-z0-9_]*\}/.test(text)) continue;

      var frag = document.createDocumentFragment();
      var re = /\{[a-z][a-z0-9_]*\}/g;
      var last = 0;
      var m;
      while ((m = re.exec(text))) {
        if (m.index > last) {
          frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        }
        frag.appendChild(createTokenEl(m[0]));
        last = m.index + m[0].length;
        changed = true;
      }
      if (last < text.length) {
        frag.appendChild(document.createTextNode(text.slice(last)));
      }
      textNode.parentNode.replaceChild(frag, textNode);
    }

    if (changed) {
      setCaretPlainOffset(rte, offset);
      syncPlaceholder(rte);
    }
    return changed;
  }

  function insertMaskToken(rte, token) {
    rte.focus();
    var sel = window.getSelection();
    if (!sel || !sel.rangeCount) {
      // append at end
      rte.appendChild(createTokenEl(token));
      rte.appendChild(document.createTextNode('\u00a0'));
      syncPlaceholder(rte);
      return;
    }
    var range = sel.getRangeAt(0);
    // Ensure selection is inside rte
    if (!rte.contains(range.commonAncestorContainer)) {
      range = document.createRange();
      range.selectNodeContents(rte);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    }
    range.deleteContents();
    var pill = createTokenEl(token);
    range.insertNode(pill);
    var space = document.createTextNode('\u00a0');
    pill.parentNode.insertBefore(space, pill.nextSibling);
    range.setStartAfter(space);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
    syncPlaceholder(rte);
  }

  function execTool(cmd) {
    document.execCommand(cmd, false, null);
  }

  ready(function () {
    var root = document.querySelector('.gm-lab-mascaras');
    if (!root) return;

    var dataEl = root.querySelector('[data-gm-lab-mascaras-data]');
    var modeloEl = root.querySelector('[data-gm-lab-mascaras-modelo]');
    var campoEl = root.querySelector('[data-gm-lab-mascaras-campo]');
    var rte = root.querySelector('[data-gm-lab-mascaras-rte]');
    var chipsEl = root.querySelector('[data-gm-lab-mascaras-chips]');
    var toolbar = root.querySelector('.gm-lab-mascaras__toolbar');
    var tilesEl = root.querySelector('[data-gm-lab-mascaras-tiles]');
    var statusEl = root.querySelector('[data-gm-lab-mascaras-status]');
    var reloadBtn = root.querySelector('[data-gm-lab-mascaras-reload]');
    var copyBtn = root.querySelector('[data-gm-lab-mascaras-copy]');

    if (!dataEl || !modeloEl || !rte || !tilesEl) return;

    var data = { masks: [], maskHelp: {}, modelos: [], products: [] };
    try {
      var raw = (dataEl.textContent || '').trim();
      if (raw.indexOf('Liquid error') !== -1) {
        throw new Error(raw.slice(0, 240));
      }
      data = JSON.parse(raw || '{}');
    } catch (err) {
      tilesEl.innerHTML =
        '<p class="gm-lab-mascaras__empty">Falha ao ler dados: ' +
        esc(err && err.message) +
        '</p>';
      return;
    }

    var modelos = (data.modelos || []).slice().sort(function (a, b) {
      return String(a.nome || a.handle).localeCompare(
        String(b.nome || b.handle),
        'pt-BR'
      );
    });
    var products = data.products || [];
    var maskHelp = data.maskHelp || {};
    var masks = data.masks || [];

    chipsEl.innerHTML = masks
      .map(function (token) {
        return (
          '<button type="button" class="gm-lab-mascaras__chip" data-mask="' +
          esc(token) +
          '" title="' +
          esc(maskHelp[token] || token) +
          '">' +
          esc(token) +
          '</button>'
        );
      })
      .join('');

    chipsEl.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-mask]');
      if (!btn) return;
      insertMaskToken(rte, btn.getAttribute('data-mask') || '');
      render();
    });

    if (toolbar) {
      toolbar.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-gm-cmd]');
        if (!btn) return;
        ev.preventDefault();
        rte.focus();
        execTool(btn.getAttribute('data-gm-cmd'));
        render();
      });
    }

    modeloEl.innerHTML = modelos
      .map(function (m) {
        var n = products.filter(function (p) {
          return p.modeloHandle === m.handle;
        }).length;
        return (
          '<option value="' +
          esc(m.handle) +
          '">' +
          esc(m.nome || m.handle) +
          ' (' +
          n +
          ')</option>'
        );
      })
      .join('');

    function currentModelo() {
      var handle = modeloEl.value;
      for (var i = 0; i < modelos.length; i++) {
        if (modelos[i].handle === handle) return modelos[i];
      }
      return null;
    }

    var STARTER =
      '<p><strong>{titulo}</strong></p>' +
      '<p>A {nome} é construída para o uso — leve na mão, firme no dia a dia.</p>' +
      '<p>Nesta versão em {material} {cor}, o acabamento conduz a leitura da peça: presença clara, sem excesso.</p>' +
      '<p>A edição {edicao} mantém a mesma construção do modelo, com identidade própria em cada tom.</p>';

    function loadCampoIntoEditor() {
      var mo = currentModelo();
      var campo = (campoEl && campoEl.value) || 'descricaoHtml';
      if (!mo) {
        setEditorHtml(rte, STARTER);
        return;
      }
      var html = (mo[campo] || '').trim();
      setEditorHtml(rte, html || STARTER);
    }

    function render() {
      var mo = currentModelo();
      var handle = mo ? mo.handle : '';
      var siblings = products.filter(function (p) {
        return p.modeloHandle === handle;
      });
      var template = serializeEditor(rte);
      syncPlaceholder(rte);

      if (!handle) {
        tilesEl.innerHTML =
          '<p class="gm-lab-mascaras__empty">Nenhum modelo disponível.</p>';
        return;
      }

      if (!siblings.length) {
        tilesEl.innerHTML =
          '<p class="gm-lab-mascaras__empty">Nenhum produto linkado a este modelo.</p>';
        return;
      }

      tilesEl.innerHTML = siblings
        .map(function (p) {
          var missing = missingMaskValues(template, p, mo.nome);
          var html = applyMasks(template, p, mo.nome);
          var left = unresolvedTokens(html);
          var warn = left.length > 0 || missing.length > 0;
          html = highlightInvalidMasks(html);

          var media = p.image
            ? '<div class="gm-lab-mascaras__tile-media"><img src="' +
              esc(p.image) +
              '" alt="" loading="lazy" width="140" height="175"></div>'
            : '<div class="gm-lab-mascaras__tile-media gm-lab-mascaras__tile-media--empty">sem foto</div>';

          var warnMsg = '';
          if (left.length > 0) {
            warnMsg =
              '<p class="gm-lab-mascaras__tile-warn">Máscara inexistente: ' +
              esc(left.join(', ')) +
              '</p>';
          }

          var notesMsg = '';
          if (missing.length > 0) {
            notesMsg =
              '<ul class="gm-lab-mascaras__tile-notes">' +
              missing
                .map(function (token) {
                  return (
                    '<li>valor ' + esc(token) + ' não encontrado</li>'
                  );
                })
                .join('') +
              '</ul>';
          }

          return (
            '<article class="gm-lab-mascaras__tile' +
            (warn ? ' gm-lab-mascaras__tile--warn' : '') +
            '">' +
            '<div class="gm-lab-mascaras__tile-side">' +
            media +
            '<p class="gm-lab-mascaras__tile-meta"><a href="' +
            esc(p.url) +
            '" target="_blank" rel="noopener">' +
            esc(p.title) +
            '</a></p>' +
            '</div>' +
            '<div class="gm-lab-mascaras__tile-body">' +
            warnMsg +
            '<div class="gm-lab-mascaras__tile-html">' +
            (html.trim() ? html : '<p><em>(vazio)</em></p>') +
            '</div>' +
            notesMsg +
            '</div></article>'
          );
        })
        .join('');

      if (statusEl && !(copyBtn && copyBtn.getAttribute('data-copied'))) {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }
    }

    modeloEl.addEventListener('change', function () {
      loadCampoIntoEditor();
      render();
    });

    if (campoEl) {
      campoEl.addEventListener('change', function () {
        loadCampoIntoEditor();
        render();
      });
    }

    rte.addEventListener('input', function () {
      promoteTypedTokens(rte);
      render();
    });
    rte.addEventListener('paste', function (ev) {
      ev.preventDefault();
      var text = (ev.clipboardData || window.clipboardData).getData('text/html');
      var plain = (ev.clipboardData || window.clipboardData).getData('text/plain');
      if (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var bad = tmp.querySelectorAll('script,style,meta,link');
        for (var i = 0; i < bad.length; i++) bad[i].remove();
        document.execCommand('insertHTML', false, decorateTokens(tmp.innerHTML));
      } else if (plain) {
        document.execCommand('insertText', false, plain);
        promoteTypedTokens(rte);
      }
      render();
    });

    if (reloadBtn) {
      reloadBtn.addEventListener('click', function () {
        loadCampoIntoEditor();
        render();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var html = serializeEditor(rte);
        function done(ok) {
          if (statusEl) {
            statusEl.hidden = false;
            statusEl.textContent = ok ? 'Copiado.' : 'Não foi possível copiar.';
          }
          if (copyBtn) copyBtn.setAttribute('data-copied', '1');
          setTimeout(function () {
            if (copyBtn) copyBtn.removeAttribute('data-copied');
            if (statusEl) {
              statusEl.hidden = true;
              statusEl.textContent = '';
            }
          }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(html).then(
            function () {
              done(true);
            },
            function () {
              done(false);
            }
          );
        } else {
          done(false);
        }
      });
    }

    if (modelos.length) {
      loadCampoIntoEditor();
      render();
    } else {
      tilesEl.innerHTML =
        '<p class="gm-lab-mascaras__empty">Nenhum metaobject modelo publicado.</p>';
    }
  });
})();
